export const COMMON_DELETE_DATA = 'COMMON_DELETE_DATA';
export const COMMON_GLOBAL_DATA = 'COMMON_GLOBAL_DATA';

const intialState = {
    notificationCount: 0,
   
};
const notificationReducer = (state = intialState, action) => {
    switch (action.type) {
        case COMMON_GLOBAL_DATA:
            return Object.assign({}, state, action.payload);
        case COMMON_DELETE_DATA:
            return intialState;
        default:
            return state;
    }
};
export default notificationReducer;